import { InfoTooltipProps } from './InfoTooltip.types';
import { IconButton, Theme, Tooltip } from '@mui/material';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { useState } from 'react';
import { Icons } from 'greener-ui-library';

const getIconSx = (theme: Theme) => ({
  width: 14,
  height: 14,
  color: theme.palette.grey[300],
  '&:hover': {
    color: theme.palette.grey[500],
  },
  transition: theme.transitions.create('color', {
    duration: theme.transitions.duration.shortest,
  }),
});

const InfoButton = ({
  tooltipText = 'Info',
  IconComponent = Info,
  iconStyle = {},
  placement = 'bottom-start',
}: Omit<InfoTooltipProps, 'style'>) => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip title={tooltipText} open={open} onClose={() => setOpen(false)} placement={placement}>
      <IconButton aria-label={tooltipText} onClick={() => setOpen(!open)}>
        <IconComponent
          sx={(theme: Theme) => ({
            ...getIconSx(theme),
            ...iconStyle,
          })}
        />
      </IconButton>
    </Tooltip>
  );
};

//Dynamic info tooltip that changes to button on mobile
export const InfoTooltip = ({
  tooltipText,
  placement = 'bottom-start',
  IconComponent = Icons.Info,
  iconStyle = {},
}: InfoTooltipProps) => {
  const { width } = useBreakpoint();

  if (width === 'xs' || width === 'sm') {
    return (
      <InfoButton tooltipText={tooltipText} IconComponent={IconComponent} iconStyle={iconStyle} placement={placement} />
    );
  }
  return (
    <Tooltip title={tooltipText} placement={placement}>
      <IconComponent
        sx={(theme: Theme) => ({
          ...getIconSx(theme),
          ...iconStyle,
        })}
      />
    </Tooltip>
  );
};
